/** @file World (skeleton-space, y-up) positions of a mesh's vertices in the posed scene, deform included. */
import { POSE_LAYOUT } from '@pose2d/core/contracts/pose';
import type { Pose, SkeletonData } from '@pose2d/core/types';
import { meshVertices } from '@pose2d/geometry/meshVertices';
import { skinVertices } from '@pose2d/geometry/skinVertices';
import { slotWorld } from '@pose2d/geometry/slotWorld';
import { invariant } from '@pose2d/std/invariant';
import type { CompiledTarget } from './compiledTarget';

/** 2 numbers per vertex, exactly what buildRender draws (geometry's own vertex writers; a new array per call). */
export function meshWorldPoints(data: SkeletonData, pose: Pose, at: CompiledTarget): Float32Array {
  const mesh = data.attachments[at.att];
  invariant(mesh?.type === 'mesh', 'meshWorldPoints: the compiled target is not a mesh');
  const out = new Float32Array(mesh.uvs.length);
  const d = pose.deform[at.att];
  const deform = d !== undefined && d.length > 0 ? d : null;
  if (mesh.skin.kind === 'skinned') {
    skinVertices(out, 0, mesh, pose.world, deform);
    return out;
  }
  const world = new Float64Array(POSE_LAYOUT.WORLD_STRIDE);
  slotWorld(pose, data, at.slot, world);
  meshVertices(out, 0, mesh, world, 0, deform);
  return out;
}
